import React from 'react';
import AttachesTable from "../../../components/attaches-table";

const Attaches = ({state, attachmentsRef, disabled}) => {
    return (
        <div>
            <AttachesTable attaches={state.attachments} gridRef={attachmentsRef}
                           fileId="candidate-professional-file-input" wrapperClass=""
                           header={false} readOnly={disabled}/>
        </div>
    );
};

export default Attaches;
